import { Component, OnInit, Optional, Inject } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';

@Component({
  selector: 'portfolioplus-container',
  templateUrl: './portfolioplus-container.component.html'
})
export class PortfolioPlusContainerComponent implements OnInit {
  hasAWRAgreed: boolean = false;
  fullEnabled: boolean = false;
  liteEnabled: boolean = false;
  colWidgt: string = 'col-xs-8';
  isAda: boolean = false;
  fullorliteenabled: boolean = false;
  constructor(private translationService: PershingTranslationService, private nxiRestService: NxiRestService, @Optional() @Inject('AppSettings') appSettings: any) {
     this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
   }

  ngOnInit() {
       this.getPortfolioPlusParams();
  }
  getPortfolioPlusParams() {
      this.nxiRestService.getNxiPortfolioRestUrlResponse('portfolioplus').subscribe(
                response => {
                    console.log('Retrived portfolioplus params : ', response);
                    if (response) {
                      this.fullEnabled = response.fullEnabled;
                      this.liteEnabled = response.liteEnabled;
                      this.hasAWRAgreed = response.hasAgreed;
                      this.fullorliteenabled = this.fullEnabled || this.liteEnabled;
                      if (this.isAda && this.hasAWRAgreed && !this.fullorliteenabled) {
                        this.colWidgt = 'col-xs-12';
                        document.querySelector('.fw-PageContents_List').setAttribute('style' , 'display:none');
                        }
                    }
                }
      );
  }
}
